import {
  SPECIFIC_SUGGESTION_FIELD_REGEX,
  SPECIFIC_SUGGESTION_REGEX
} from 'core/constants/regex';
import { SelectedSuggestion } from 'modules/candidate-profile/types/SelectedSuggestion';

export type MessageSuggestionsAndText = {
  suggestions: SelectedSuggestion[];
  text: string;
};

/**
 * Splits a stored message body back into the suggestions that were selected
 * and the free text that was typed alongside them.
 */
export const splitMessageIntoSuggestionsAndText = (
  messageBody: string
): MessageSuggestionsAndText => {
  const suggestions = Array.from(
    messageBody.matchAll(SPECIFIC_SUGGESTION_REGEX)
  ).map(([tag, text]) => {
    const field = tag.match(SPECIFIC_SUGGESTION_FIELD_REGEX)?.[1];
    return { text, ...(field ? { field } : {}) };
  });

  const text = messageBody.replace(SPECIFIC_SUGGESTION_REGEX, '').trim();

  return { suggestions, text };
};
